module.exports = __webpack_public_path__ + "static/media/mockup.d3803b2e.png";